module.exports = __webpack_public_path__ + "img/esg-3-2.41cc45ad.png";